module.exports = "images/what-drives-us_poster@2x.webp";